import React, { Suspense, lazy } from 'react';
const LazyPurchaseToast = lazy(() => import('./PurchaseToast').then(m => ({
  default: m.PurchaseToast
})));
export function Hero() {
  return <section className="relative bg-transparent text-slate-900 flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-12 pb-2 md:py-20 overflow-hidden font-sans" data-id="element-105">
      {/* Brand Header */}
      <div className="flex items-center gap-2 mb-1 md:mb-8" data-id="element-106">
        <span className="text-emerald-600 font-black tracking-widest text-sm md:text-sm uppercase" data-id="element-107">
          BIOLOGÍA EN ACCIÓN™
        </span>
      </div>

      {/* Main Title */}
      <h1 className="text-4xl md:text-7xl lg:text-8xl font-black text-center max-w-5xl leading-[1] mb-2 md:mb-12" data-id="element-108">
        Biología en Acción <br data-id="element-109" />
        <span className="text-emerald-600 text-[28px]" data-id="element-110">
          Tu año resuelto en 30 minutos.
        </span>
      </h1>

      {/* Product Visual Mockup */}
      <div className="relative w-full max-w-[390px] md:max-w-[750px] mb-2 md:mb-12" data-id="element-111">
        <img src="https://cdn.magicpatterns.com/uploads/86GiU4ZAGwiiyNsbc8BdYu/ChatGPT_Image_17_jun_2026,_10_06_09_p.m..png" alt="Maqueta del MegaPack Biología en Acción" width={1024} height={1024} fetchPriority="high" loading="eager" decoding="async" className="w-full h-auto rounded-3xl shadow-2xl" data-id="element-112" />
      </div>

      {/* Quote and Sub-headline */}
      <div className="text-center space-y-1 mb-3 md:mb-10 max-w-2xl animate-fade-in" data-id="element-113">
        <p className="text-emerald-700 italic text-lg md:text-2xl font-medium px-2 leading-tight" data-id="element-114">
          "Planificación completa para educación secundaria."
        </p>
        <p className="text-slate-600 text-xs md:text-xl font-bold" data-id="element-115">
          7 Tomos + 3 Bonos + Sistema VIP
        </p>
      </div>

      {/* CTA Button */}
      <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="w-full max-w-xs md:max-w-none bg-green-500 hover:bg-green-600 active:scale-95 text-white font-black text-lg md:text-2xl py-4 md:py-5 px-6 md:px-10 rounded-2xl shadow-[0_0_20px_rgba(34,197,94,0.4)] flex items-center justify-center gap-3 transition-all mb-4 md:mb-12 animate-fade-in btn-neon" data-id="element-116">
        <span data-id="element-117">🧬</span>
        <span data-id="element-118">QUIERO MI MEGAPACK</span>
      </button>

      {/* Trust Badges */}
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-12 text-[9px] md:text-base font-bold text-slate-500 animate-fade-in" data-id="element-119">
        <div className="flex items-center gap-2" data-id="element-120">
          <span className="text-xl" data-id="element-121">📄</span> 100% PDF
        </div>
        <div className="flex items-center gap-2" data-id="element-122">
          <span className="text-xl" data-id="element-123">⚡</span> Acceso inmediato
        </div>
        <div className="flex items-center gap-2" data-id="element-124">
          Contenidos fundamentales de Biología para educación secundaria
        </div>
      </div>
    </section>;
}